import { createFileRoute } from "@tanstack/react-router";
import { ReglerPage } from "./regler";

export const Route = createFileRoute("/en/rules")({
  head: () => ({
    meta: [
      { title: "Listing rules on Sellavo – what applies to text and photos" },
      { name: "description", content: "What you may and may not publish on Sellavo, for both text and images." },
      { property: "og:title", content: "Listing rules on Sellavo – what applies to text and photos" },
      { property: "og:description", content: "What you may and may not publish on Sellavo, for both text and images." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en/rules" }],
  }),
  component: ReglerPage,
});
